import script from "./GetFilterRegions.vue?vue&type=script&lang=js"
export * from "./GetFilterRegions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f66bde9"]])

export default __exports__